// NOTE we use modules because we cannot make sub classes in typescript
export const STARTSCHERM_CONSTANTS = {
    STORAGE_KEY_PREFIX: 'domain.startscherm.',
    STARTSCHERM_URL_SEGMENT: '/a/startscherm/v2/web'
} as const;
